import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useToggleSeedSown() {
  return useMutation(api.seedTracking.mutations.toggleSown).withOptimisticUpdate(
    (localStore, { gardenId, plantId, hasSown }) => {
      const current = localStore.getQuery(api.seedTracking.queries.getSeedTracking, { gardenId });
      if (current === undefined) return;

      const exists = current.some((s) => s.plantId === plantId);
      if (exists) {
        localStore.setQuery(
          api.seedTracking.queries.getSeedTracking,
          { gardenId },
          current.map((s) => (s.plantId === plantId ? { ...s, hasSown } : s))
        );
      } else {
        localStore.setQuery(api.seedTracking.queries.getSeedTracking, { gardenId }, [
          ...current,
          { plantId, hasSown },
        ]);
      }
    }
  );
}
